// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__XOXan","title":"Info_title__23eTm","selects":"Info_selects__Yp4NV","requiredAsterisk":"Info_requiredAsterisk__BU36B"};